import React, { useState, ChangeEvent, useEffect, useRef, MutableRefObject } from 'react';
import Layer from 'ol/layer/Layer';
import { BgisIcon } from '../../../../icon/BgisIcon';
import { setVisible as setLayerVisible, isVisible, toggleVisibility as toggleLayerVisibility, visible as visibleEnum } from './layer';
import { BgisButtonIcon } from '../../../../icon';
import LayerGroup from 'ol/layer/Group';
 

export interface BgisLegendEntryBaseProps {
  id?: string;
  icon?: string;
  label: string;
  layer?: Layer | LayerGroup;
  layers?: Layer[]; // in the case of a radio button
  name?: string;
  value?: string;
  layerIdCounter?:number;
  collapsable?: 'closed' | 'open'; // Whether childs are shown on default (if any)
}

export interface BgisLegendEntryProps extends BgisLegendEntryBaseProps {
  name?: string;
  value?: string;
  type?: 'radio' | 'checkBox';
  onChange?(event: ChangeEvent<HTMLInputElement>): void;
  children?: React.ReactElement<BgisLegendEntryProps>[] | React.ReactElement<BgisLegendEntryProps>;
}

export const BgisLegendEntry: React.FC<BgisLegendEntryProps> = ({ id, icon, label, name, value, layer, layers, onChange, collapsable, children , layerIdCounter }) => {


  const [internalLayerIdCounter, setInternalLayerIdCounter] = useState(layerIdCounter ? layerIdCounter : 0);

   
  const [visible, setVisible] = useState(layer ? isVisible(layer) : visibleEnum.false);

  // const input : MutableRefObject<HTMLInputElement | null> = useRef(null);  

  useEffect(() => {
    if (layer && isVisible(layer) !== visible) {
      setVisible(isVisible(layer));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layerIdCounter]);

  /* Holds the state wheter the child entries are shown (if there are any) */
  const [isCollapsable, setCollapsable] = useState<string | undefined>(collapsable);



  /**
   * Toggles the visibility.
   * @param event Toggles the visibility.
   */
  const toggleVisibility = (event: ChangeEvent<HTMLInputElement>) => {

    if (layer) {
      const changedVisibility = toggleLayerVisibility(layer);
      setLayerVisible(changedVisibility === visibleEnum.true, layer);
     // setVisible(isVisible(layer));
      // set all other layers visibility to false
      if (layers) {
        layers.forEach(lay => {
          if (lay !== layer) {
            console.log(lay);
            lay.setVisible(false);
          }
        });
      }
    }
    if (onChange) {
      onChange(event);
    }
    setInternalLayerIdCounter(internalLayerIdCounter+1);
  };



  const toggleChilds = () => setCollapsable(isCollapsable ? (isCollapsable === 'open' ? 'closed' : 'open') : undefined);

  return (
    <>
      <li className='bgis-hz bgis-border-bottom bgis-hover'>
        {layer && (
          <input
            className="bgis-icon"
            type={layer && layers ? 'radio' : 'checkBox'}
            value={value ? value : label}
            ref={el => el && (el.indeterminate = visible === visibleEnum.indeterminate)}
            checked={visible === visibleEnum.true}
         //   defaultChecked={visible === visibleEnum.true}
            onChange={toggleVisibility}
          />
        )}
        {icon && <BgisIcon src={icon} />}
        <span className="bgis-txt">
          <label>{label}</label>
        </span>
        {isCollapsable && children && (
          <BgisButtonIcon iconName={isCollapsable === 'open' ? 'bgis-icon-chevron-up' : 'bgis-icon-chevron-down'} onClick={toggleChilds}></BgisButtonIcon>
        )}
      </li>
      {((children && !isCollapsable) || (children && isCollapsable && isCollapsable === 'open')) && (
        <li>
          <ul className="bgis-list-dense">{children}
          </ul>
        </li>
      )}
    </>

  );
};
